import { useCallback, useEffect } from 'react';
import { createElement } from 'react';
import { getSelfEmoji } from '../utils/formatContent';
import TypedText from '../typed-text';
import LoadingDot from './LoadingDot';
import './style.less';
function AIDialog(props) {
    const { type = 'text', text = '', role = 'bot', onComplete, pageData: { controlFlag, scrollBottom, isHistory, pvParameter, ANSWERTYPE, answerType } = {}, config: { answerChannel = '' } = {}, ...otherProps } = props;
    const showAIHint = ANSWERTYPE === '1';
    const isSSEAnswer = answerType === '1';
    const handleControl = useCallback((flag) => {
        if (isHistory) {
            return;
        }
        switch (flag) {
            case '2':
                setTimeout(() => {
                }, 0);
                break;
            default:
        }
    }, []);
    useEffect(() => {
        controlFlag && handleControl(controlFlag);
        if (role === 'bot' && !['loading', 'thinking'].includes(type)) {
        }
    }, []);
    return (createElement("div", null, type === 'loading' ? (createElement(LoadingDot, null)) : type === 'thinking' ? (createElement(LoadingDot, { text: "正在思考中" || text })) : (createElement("div", null,
        createElement(TypedText, Object.assign({ text: getSelfEmoji(text), onComplete: onComplete, isHistory: isHistory, typeSpeed: isSSEAnswer ? 0 : 40 }, otherProps)),
        showAIHint && (createElement("div", { className: "ai-generated-hint" }, "\u4EE5\u4E0A\u5185\u5BB9\u7531AI\u751F\u6210"))))));
}
export default AIDialog;
